import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { t } from "../../components/translate";
import DebouncedTextField from "../../components/DebouncedTextField";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "./Assessment.module.css";

const MAX_LENGTH = 2000;

const HOPI = ({
  assessmentHOPI,
  onChange
}: {
  assessmentHOPI: string;
  onChange: (value: string) => void;
}): React.ReactNode => {
  const assessmentLabels = useAssessmentLabel();
  const [localValue, setLocalValue] = React.useState(assessmentHOPI || "");

  useEffect(() => {
    setLocalValue(assessmentHOPI || "");
  }, [assessmentHOPI]);

  return (
    <Box data-testmation="PastHistoryOfAllergy" className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.hopi}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <DebouncedTextField
          margin="dense"
          id="outlined-basic"
          data-testmation="hopiTextField"
          fullWidth
          multiline
          variant="outlined"
          minRows={3}
          maxRows={3}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { maxLength: MAX_LENGTH },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          placeholder={t("assessment.typeHOPI")}
          value={localValue}
          onChange={(e) => {
            setLocalValue(e.target.value);
            onChange(e.target.value);
          }}
          debounceAt={400}
          helperText={`${localValue.length}/${MAX_LENGTH}`}
        />
      </Box>
    </Box>
  );
};

export default HOPI;
